module.exports = __webpack_public_path__ + "static/preset-image-right-a7b9ec65042bc9b300be233b4318cb7c.png";